new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
    mounted() {
        const faixCupom = document.querySelector('.faixa-cupom');
        if (faixCupom) {
            const btn = document.getElementById("copiar-cupom");
            const span = document.getElementById("tc-coupon");

            if (btn && span) {
                btn.addEventListener("click", (e) => {
                    e.preventDefault();

                    // Pega só o texto do cupom, sem o botão
                    const texto = span.childNodes[0].textContent.trim();

                    // Cria um elemento temporário para copiar o texto
                    const tempInput = document.createElement("input");
                    tempInput.value = texto;
                    document.body.appendChild(tempInput);
                    tempInput.select();

                    document.execCommand("copy");
                    document.body.removeChild(tempInput);

                    alert("Cupom copiado: " + texto);
                });
            }
        }
    },
});

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: false,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        //fade: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function (event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    $('#carrousel-categories-banners').slick({
        swipeToSlide: true,
        touchThreshold: 100,
        dots: false,
        arrows: true,
        autoplay: false,
        infinite: true,
        mobileFirst: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                },
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                },
            },
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 6,
                },
            },
        ],
    });

    $('#js-carrousel-comunicado').slick({
        swipeToSlide: true,
        touchThreshold: 100,
        arrows: false,
        dots: true,
        infinite: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        delay: 2000,
        speed: 700,

        responsive: [
            {
                breakpoint: 991,
                settings: 'unslick'
            }
        ]
    });

    $('.mini-banner-carrossel').slick({
        swipeToSlide: true,
        touchThreshold: 100,
        arrows: false,
        dots: true,
        infinite: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        delay: 2000,
        speed: 700,

        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    arrows: true,
                    prevArrow: $(".home-product__list .mini-banner-carrossel-arrows .count-prev3"),
                    nextArrow: $(".home-product__list .mini-banner-carrossel-arrows .count-next3"),
                }
            }
        ]
    });



    waitForElementToExist('.rotation-vitrine').then(element => {
        $('#carrousel-product-list').slick({
            arrows: true,
            prevArrow: $(".count .count-prev"),
            nextArrow: $(".count .count-next"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        });
        $('#carrousel-product-list2').slick({
            arrows: true,
            prevArrow: $(".count .count-prev2"),
            nextArrow: $(".count .count-next2"),
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        });

        if (element) {
            let rotationNames = element.querySelectorAll('.vitrines-select .vitrines-select-name');
            let initVitrine = element.querySelectorAll('.vitrines-products .vitrines-products-item');
            let allLinks = element.querySelectorAll('.see-all .btn-view-all');
            initVitrine = Array.from(initVitrine);

            if (rotationNames.length && initVitrine.length) {
                initVitrine[0].classList.add('active');
                rotationNames[0].classList.add('active');
                if (allLinks.length) {
                    allLinks[0].classList.add('active');
                }
                function activeTab(index) {
                    initVitrine.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    if (allLinks.length) {
                        allLinks.forEach((content) => {
                            content.classList.remove('active');
                        });
                    }
                    initVitrine[index].classList.add('active');
                    rotationNames[index].classList.add('active');
                    if (allLinks.length) {
                        allLinks[index].classList.add('active');
                    }

                    // Atualizar classe no contêiner .count
                    $('.count').attr('class', function (i, c) {
                        return c.replace(/(^|\s)count-\S+/g, '');
                    }).addClass(`count-${index + 1}`);

                    // Refresh slick carousels and bind afterChange event
                    const carouselIds = [
                        '#carrousel-product-list',
                        '#carrousel-product-list2',
                    ];
                    carouselIds.forEach(id => {
                        const $carousel = $(id);
                        if ($carousel.hasClass('slick-initialized')) {
                            const totalItems = $carousel.slick('getSlick').slideCount;
                            const $countFirst = $('.count-content .count-first');
                            const $countEnd = $('.count-content .count-end');

                            $countEnd.text(('0' + totalItems));
                            $carousel.slick('refresh').on('afterChange', function (event, slick, currentSlide) {
                                $countFirst.text(('0' + (currentSlide + 1)));
                            });
                        }
                    });
                }

                rotationNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    }, { passive: true });
                });

                // Initial update for the first active tab
                activeTab(0);
            }
        }

        $('#carrousel-product-list, #carrousel-product-list2, #carrousel-product-list3, #carrousel-product-list4, #carrousel-product-list5, #carrousel-product-list6').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });

    waitForElementToExist('#carrousel-product-ratings').then(element => {
        $('#carrousel-product-ratings').slick({
            dots: true,
            appendArrows: $('.product-ratings .append-arrow'),
            arrows: true,
            autoplay: true,
            infinite: true,
            mobileFirst: true,
            speed: 1000,
            autoplaySpeed: 4000,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    }
                }
            ]
        });
    });
})